import LocalizedStrings, { LocalizedStringsMethods } from 'react-localization';
import IStepperConfig from '../../types/StepperConfig.types';
import en from './english';
import fr from './french';
import es from './spanish';

export interface ILanguageStrings extends LocalizedStringsMethods {
  steps: IStepperConfig;
  backButtonLabel: string;
  continueButtonLabel: string;
  affirmativeLabel: string;
  negativeLabel: string;
  expandIconTooltip: string;
  collapseIconTooltip: string;
  emailCheck: {
    languageLabel: string;
    validEmail: string;
    enterEmail: string;
    welcome: string;
  };
  emailValidationCode: {
    emailValidationTitle: string;
    termsOfUse: string;
    aknowledge: string;
    validationCodeLabel: string;
    sendCodeLabel: string;
    resendCodeLabel: string;
    validationErrorMessage: string;
    incorrectValidationCode: string;
    userNotAllowToProceedMsg: string;
    paSupportEmail: string;
    reSentLabel: string;
    modalActiveAccount: string;
    modalEmailExistsText: string;
    modalEmailExistsGuide: string;
    newUserAccountLabel: string;
  };
  requestAccess: {
    helpText: string;
    textAreaLabel: string;
    modalEmailNotInvitedText: string[];
    eventCoordinator: string;
    portalOwner: string;
    contractOwner: string;
    modalCancelButton: string;
    modalOkButton: string;
    modalLoginButton: string;
  };
  userInfo: {
    salutation: { label: string; value: string }[];
    firstName: string;
    lastName: string;
    workPhone: string;
    jobTitle: string;
    timeZone: string;
    reStart: string;
  };
  companySelection: {
    helpText: string;
    companySearchLabel: string;
    locationControlsHelpText: string;
    siteName: string;
    address1: string;
    address2: string;
    country: string;
    city: string;
    stateProvince: string;
    zip: string;
    phoneNumber: string;
    siteTypeCode: string;
    companyNotFound: string;
    tableCompanyNotFound: string;
    tableTitle: string;
    tableSelect: string;
    tableSiteName: string;
    tableAddress: string;
    tableStateProvince: string;
    tableZip: string;
    tablePhone: string;
    loadingLabel: string;
    radioLabel: string;
    companyDuplicatedName: string;
    sortingLabelAlpha: string;
    sortingLabelUsers: string;
    sortingLabelRelevancy: string;
    sortAscending: string;
    sortDescending: string;
    activeAccountsLabel: string;
    domainSearchLabel: string;
    errorCompanyAlreadyRegistered: string;
  };
  companyBio: {
    companyLegalName: string;
    companyDoingBusinessAs: string;
    companyParentCompany: string;
    yearCompanyWasFounded: string;
    numberOfPermanentEmployees: string;
    supplierCompanyOwnership: string;
    supplierCompanyOwnershipOptions: { label: string; value: string }[];
    unionizedCompany: string;
    companyPhoneNumber: string;
    companyWebsite: string;
    errorCompanyWebsite: string;
    companyEmailAddress: string;
    errorEmailAddress: string;
    companyTaxIdNumber: string;
    errorTaxIdNumber: string;
    dunsNumber: string;
    errorDunsNumber: string;
    primaryNAICSCode: string;
    secondaryNAICSCode: string;
    errorNAICSCode: string;
    annualRevenueLabel: string;
  };
  diversity: {
    radioGroupLabel: string;
    errorDiversityList: string;
    errorUploadingFile: string;
    errorRequiredField: string;
    errorForbiddenCharacters: string;
    errorPermitedTypeFile: string;
    errorDates: string;
    permitedTypeFileTooltip: string;
    tableColumns: { id: string; label: string }[];
    note: string;
    modalText: string;
    modalCancelButton: string;
    modalDeleteButton: string;
  };
  productsServices: {
    searchPlaceholder: string;
    cancelIconTooltip: string;
    selectedProductsListTitle: string;
    addProductTooltip: string;
    removeProduct: string;
  };
  confirmation: {
    helperText: string;
    submitButtonText: string;
    userNameError: string;
    passwordError: string;
    passwordConfirmationError: string;
    usernameLabel: string;
    passwordnameLabel: string;
    confirmationPassLabel: string;
    usernameTaken: string;
    successResponse: string;
    errorResponse: string;
  };
  common: {
    tagInstructionPrimary: string;
    tagInstructionSecondary: string;
  };
  footer: {
    poweredBy: string;
    rightsReserved: string;
    termsOfUse: string;
    privacyStatement: string;
    contactSupport: string;
  };
  registrationLinkExpired: {
    headerText: string;
    title: string;
    description: string;
    here: string;
  };
}

let strings = new LocalizedStrings({
  en,
  fr,
  es
});

export default strings;
